import { render, staticRenderFns } from "./CatalogBoxItem.vue?vue&type=template&id=70d1d065&scoped=true&"
import script from "./CatalogBoxItem.vue?vue&type=script&lang=js&"
export * from "./CatalogBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBoxItem.vue?vue&type=style&index=0&id=70d1d065&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1d065",
  null
  
)

export default component.exports